const imageSlide = [
    {url: '../background/mosque1.webp'},
    {url: '../background/mosque2.webp'},
    {url: '../background/mosque3.webp'},
    {url: '../background/mosque4.webp'},
    {url: '../background/mosque5.webp'},
    {url: '../background/mosque6.webp'},
    {url: '../background/mosque7.webp'},
    {url: '../background/mosque8.webp'},
    {url: '../background/mosque9.webp'},
    {url: '../background/mosque10.webp'},
    {url: '../background/mosque11.webp'},
    {url: '../background/mosque12.webp'}
]

export default imageSlide;